import { Component, output, OutputEmitterRef, signal, WritableSignal } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { BaseComponent, MessageBoxComponent, RadioComponent } from '@sircon/sircon-ui-framework';
import { MfaAuthenticatorSetupComponent } from 'src/components/mfa-enrollment/authenticator-setup/mfa-authenticator-setup.component';
import { HelpService } from 'src/services/help.service';

export type MfaEnrollmentMethod = 'SMS' | 'AUTHENTICATOR';

@Component({
    selector: 'app-mfa-enrollment-required',
    templateUrl: './mfa-enrollment-required.component.html',
    styleUrls: ['./mfa-enrollment-required.component.less'],
    imports: [FormsModule, RadioComponent, MessageBoxComponent, MfaAuthenticatorSetupComponent],
    standalone: true
})
export class MfaEnrollmentRequiredComponent extends BaseComponent {
    verified: OutputEmitterRef<void> = output<void>();

    // Authenticator App is the only enrollable method today, so it is selected by default.
    // Text Message is displayed per design but disabled since SMS enrollment does not yet exist.
    selectedMethod: MfaEnrollmentMethod = 'AUTHENTICATOR';
    showAuthenticatorSetup: WritableSignal<boolean> = signal(false);

    constructor(private helpService: HelpService) {
        super();
    }

    continue(): void {
        this.showAuthenticatorSetup.set(true);
    }

    authenticatorLearnMoreUrl(): string {
        return this.helpService.getInsuranceHelpPath();
    }
}
